import type {PilotDemoStatus} from "./types";

const labels=[
 ["faqAnswered","Pregunta frecuente respondida"],
 ["availabilitySlots","Disponibilidad consultada"],
 ["appointmentCreated","Cita creada"],
 ["appointmentRescheduled","Cita reprogramada"],
 ["appointmentCancelled","Cita cancelada"],
 ["messageCaptured","Mensaje recogido"],
 ["callEnded","Llamada finalizada"],
] as const;

export default function PilotDemoPanel({demo}:{demo:PilotDemoStatus}){
 const duration=Math.max(0,new Date(demo.endedAt).getTime()-new Date(demo.startedAt).getTime());
 return <section className="workspace pilot-demo" aria-labelledby="pilot-demo-title"><header className="workspace-head">
  <div><span className="eyebrow">Pilot Edition · entorno interno</span>
   <h1 id="pilot-demo-title">Recorrido comercial guiado</h1>
   <p>Una ejecución completa y sintética, separada de cualquier evidencia real.</p></div>
  <span className="status demo-only" role="status" aria-label="Estado: no promocionable">No promocionable</span>
 </header>
 <section className="pilot-hero panel">
  <div><span className="eyebrow">Última ejecución</span><h2>Recepción resuelta de principio a fin</h2>
   <p>Mila atendió una consulta, comprobó agenda, gestionó el ciclo de una cita y dejó un mensaje visible para el negocio.</p></div>
  <div className="pilot-run-meta"><span><small>Estado</small><b>Completado</b></span>
   <span><small>Duración</small><b>{(duration/1000).toFixed(1)} s</b></span>
   <span><small>Slots</small><b>{demo.steps.availabilitySlots}</b></span></div>
 </section>
 <section className="pilot-grid"><article className="panel pilot-timeline">
  <div className="panel-title"><div><span className="eyebrow">Secuencia</span><h2>Qué ocurrió</h2></div>
   <time dateTime={demo.endedAt}>{new Date(demo.endedAt).toLocaleString("es-ES")}</time></div>
  <ol className="pilot-steps" aria-label="Hitos confirmados del recorrido">{labels.map(([key,label],index)=>{
   const value=key==="availabilitySlots"?demo.steps.availabilitySlots>0:demo.steps[key];
   return <li className="pilot-step" key={key}><span aria-hidden="true">{value?"✓":"!"}</span>
    <div><b>{index+1}. {label}</b><small>{key==="availabilitySlots"?demo.steps.availabilitySlots+" horarios ofrecibles":"Resultado confirmado por el recorrido local"}</small></div>
    <i aria-label={value?"Resultado correcto":"Resultado bloqueado"}>{value?"Correcto":"Bloqueado"}</i></li>;
  })}</ol>
 </article>
 <aside className="pilot-aside">
  <article className="panel pilot-boundaries"><span className="eyebrow">Límites visibles</span>
   <h2>La demo no finge producción</h2>
   <ul><li><span>✓</span>Datos exclusivamente sintéticos</li>
    <li><span>✓</span>Agenda local provider-neutral</li>
    <li><span>✓</span>Tenant aislado con FORCE RLS</li>
    <li><span>—</span>Voz externa no conectada</li>
    <li><span>—</span>Calendario externo no conectado</li>
    <li><span>—</span>Sin clientes ni facturación real</li></ul>
  </article>
  <article className="panel founder-cue"><span className="eyebrow">Guion para Manu</span>
   <h2>Explica el resultado</h2>
   <p>“MIL respondió información aprobada, consultó la agenda antes de actuar y dejó cada paso visible. Aquí todo es sintético; las conexiones reales siguen bloqueadas por sus gates.”</p>
   <small>Run {demo.runKey}</small>
  </article>
 </aside></section>
 <footer className="section-foot">Recibo local {demo.id.slice(0,8)} · {demo.mode.replaceAll("_"," ")}</footer>
 </section>;
}
